import aboutReducer from './reducers'

export {default as aboutTypes} from './types'
export {default as aboutActions} from './actions'
export {default as aboutSelectors} from "./selectors"
export {default as aboutSagas} from './operations'
export {default as aboutUtils} from './utils'

export default aboutReducer